import { IconAlertTriangle } from '@tabler/icons-react'

import { Button } from '@/components/sui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/sui/tooltip'
import { useComponentTranslation } from '@/hooks/use-component-translation'

import locales from './locales'

interface NoPlanBannerProps {
  collapsed?: boolean
  onCtaClick: () => void
}

export function NoPlanBanner({
  collapsed = false,
  onCtaClick,
}: NoPlanBannerProps) {
  const { t } = useComponentTranslation(locales)

  if (collapsed) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            render={
              <Button
                size="icon"
                aria-label={t('collapsedTooltip')}
                className="h-12 w-full bg-yellow-400 text-zinc-900 hover:bg-yellow-500 focus-visible:border-yellow-400 focus-visible:ring-yellow-400/50"
                onClick={onCtaClick}
              />
            }
          >
            <IconAlertTriangle className="h-5 w-5" />
          </TooltipTrigger>
          <TooltipContent side="right">
            <p>{t('collapsedTooltip')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return (
    <div className="flex flex-col gap-3 rounded-lg bg-gradient-to-br from-yellow-400 to-yellow-500 p-3 text-zinc-900">
      <div className="flex items-start gap-2">
        <div className="mt-0.5 flex size-5 shrink-0 items-center justify-center rounded-md bg-black/10">
          <IconAlertTriangle className="size-3" />
        </div>
        <span className="text-sm font-semibold">{t('title')}</span>
      </div>

      <p className="text-xs leading-snug opacity-80">{t('description')}</p>

      <Button
        size="sm"
        onClick={onCtaClick}
        className="mt-1 w-full bg-zinc-900 text-white hover:bg-zinc-800 focus-visible:border-zinc-900 focus-visible:ring-zinc-900/40"
      >
        {t('cta')}
      </Button>
    </div>
  )
}
